module.exports = __webpack_public_path__ + "img/map_madrid.c000c2ca.png";